import BaseComponent from "../../../../baseComponent.js";

export default class DecimalOptions extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      length: props.decimalPlaces
    };
    this.maxLength = 10;
  }

  onOptionValueClick(length) {
    this.props.onOptionValueClick(length);
    this.setState({length: length});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({length: nextProps.decimalPlaces});
  }

  showOptions(ref) {
    let element = this.refs[ref];
    this.props.onOptionClick(element);
  }

  render() {
    let options = [];
    for (let i = this.props.min; i <= this.props.max; i++) {
      options.push(<div className="item" key={i} onClick={() => this.onOptionValueClick(i)}>{i}</div>);
    }
    return (
      <div>
        <div className='tw-option-container'>
          <div className='t-col single' data-cat='precision' ref="length"
               onClick={() => this.showOptions("lengthOptions")} style={{textAlign: 'left', padding: '0 10px'}}>
            {this.props.label}: {this.state.length}
          </div>
        </div>
        <div className='option-list length' ref="lengthOptions"
             style={{width: '168px', height: '140px', overflowY: 'auto'}}>
          { options }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/decimalOptions.jsx